export default __webpack_public_path__ + "static/bouche-982bb59b0d8d463eaaca871e516bbe5f.png";